/**
 * Game PIN Display Component
 *
 * Displays the 6-digit game PIN in a large, readable format.
 */

interface GamePinProps {
  pin: string;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
  copyable?: boolean;
}

export function GamePin({ pin, size = 'lg', showLabel = true, copyable = true }: GamePinProps) {
  const sizeClasses = {
    sm: 'text-2xl tracking-[0.3em]',
    md: 'text-4xl tracking-[0.4em]',
    lg: 'text-6xl tracking-[0.5em]',
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(pin);
    } catch (error) {
      console.error('Failed to copy PIN:', error);
    }
  };

  return (
    <div className="text-center">
      {showLabel && (
        <p className="text-sm font-medium text-purple-300 uppercase tracking-wider mb-2">
          Game PIN
        </p>
      )}
      <div
        className={`font-mono font-bold text-white ${sizeClasses[size]} ${
          copyable ? 'cursor-pointer hover:text-purple-200 transition-colors' : ''
        }`}
        onClick={copyable ? handleCopy : undefined}
        title={copyable ? 'Click to copy' : undefined}
      >
        {pin}
      </div>
      {copyable && (
        <p className="text-xs text-purple-400 mt-1">Click to copy</p>
      )}
    </div>
  );
}

export default GamePin;
